import { IconButton, Stack, SvgIcon, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { getStyles } from "./styles";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../../../locales/tokens";

interface IProps {
  isDisabled?: boolean;
  taskList: any[];
  defineCurrentTask: (index: number, questionId: number) => void;
  removeTask: (id: number) => void;
  changeTaskOrder: (type: "UP" | "DOWN", index: number) => void;
}

export const TaskList: FC<IProps> = ({
  defineCurrentTask,
  removeTask,
  taskList,
  isDisabled,
  changeTaskOrder,
}) => {
  const { t } = useTranslation();
  const styles = useMemo(() => getStyles(), []);

  const defineTask = (task: any, index: number) => {
    let type;
    if (task?.document) {
      type = { name: task.document.name, type: t(tokens.course.document) };
    } else if (task?.quiz) {
      type = { name: task.quiz.name, type: t(tokens.course.test) };
    } else if (task?.questionnaire) {
      type = { name: task.questionnaire.name, type: t(tokens.course.quiz) };
    }

    const prev = taskList[index - 1];
    const next = taskList[index + 1];

    const upDisabled = !prev || prev.day !== task.day;
    const downDisabled = !next || next.day !== task.day;

    return {
      upDisabled,
      downDisabled,
      ...type,
    };
  };

  return (
    <>
      {taskList?.map((task: any, index: number) => {
        const currentTask = defineTask(task, index);
        const key = `courseTask${task.id}`;
        return (
          <>
            {!!currentTask ? (
              <Stack
                id={key}
                key={key}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={3}
                sx={styles.answer}
              >
                <Typography variant="h6" fontWeight={600} width="10%">
                  {task.day + t(tokens.course.numDay)}
                </Typography>
                <Typography variant="body1" width="60%" sx={styles.name}>
                  {!!currentTask && currentTask.name}
                </Typography>
                <Typography variant="body1" width="20%" sx={styles.textField}>
                  {!!currentTask && currentTask.type}
                </Typography>
                <Stack
                  direction="row"
                  flexWrap="wrap"
                  width="160px"
                  flexShrink={0}
                >
                  <IconButton
                    onClick={() => changeTaskOrder("UP", index)}
                    disabled={isDisabled || currentTask.upDisabled}
                  >
                    <SvgIcon>
                      <KeyboardDoubleArrowUpIcon />
                    </SvgIcon>
                  </IconButton>
                  <IconButton
                    onClick={() => changeTaskOrder("DOWN", index)}
                    disabled={isDisabled || currentTask.downDisabled}
                  >
                    <SvgIcon>
                      <KeyboardDoubleArrowDownIcon />
                    </SvgIcon>
                  </IconButton>
                  <IconButton
                    onClick={() => defineCurrentTask(index, task.id)}
                    disabled={isDisabled}
                  >
                    <SvgIcon>
                      <EditIcon />
                    </SvgIcon>
                  </IconButton>
                  <IconButton
                    onClick={() => removeTask(task.id)}
                    disabled={isDisabled}
                  >
                    <SvgIcon>
                      <DeleteIcon />
                    </SvgIcon>
                  </IconButton>
                </Stack>
              </Stack>
            ) : (
              <Stack key={key} />
            )}
          </>
        );
      })}
    </>
  );
};
